<template>
  <div class="projects">
    <div class="page-header">
      <h2>项目管理</h2>
      <p>查看和管理项目信息</p>
    </div>
    
    <div class="page-content">
      <el-table
        :data="projects"
        v-loading="loading"
        style="width: 100%">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="unit_name" label="项目单位" min-width="200"></el-table-column>
        <el-table-column prop="created_at" label="创建时间" width="180"></el-table-column>
        <el-table-column prop="updated_at" label="更新时间" width="180"></el-table-column>
      </el-table>
      
      <div style="margin-top: 20px; text-align: center;">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          :total="projectsTotal"
          layout="prev, pager, next, total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'Projects',
  data() {
    return {
      loading: false,
      currentPage: 1,
      pageSize: 10
    }
  },
  computed: {
    ...mapState(['projects', 'projectsTotal'])
  },
  mounted() {
    this.loadData()
  },
  methods: {
    ...mapActions(['loadProjects']),
    
    async loadData() {
      this.loading = true
      try {
        await this.loadProjects({
          page: this.currentPage,
          size: this.pageSize
        })
      } finally {
        this.loading = false
      }
    },
    
    handleCurrentChange(page) {
      this.currentPage = page
      this.loadData()
    }
  }
}
</script>

<style scoped>
.page-header {
  margin-bottom: 20px;
}

.page-header h2 {
  margin: 0 0 10px 0;
  color: #303133;
}

.page-header p {
  margin: 0;
  color: #909399;
}
</style>
